import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getIwasConfig = (t: TranslateFunction): GiveawayConfig => {
  return createBaseConfig({
    theatricalSlug: slugs.iWasAStranger,
    heroTitle: t('giveawayHeroTitleIwas', 'Win a Trip for 2 to See the Mediterranean'),
    logoUrl: angelImagesUrl('v1761590758/iwas/stranger-logo-white.webp'),
    footerLogoUrl: angelImagesUrl('v1761590758/iwas/stranger-logo-white.webp'),
    inTheatersText: t('inTheatersIwas', 'In theaters January 9, 2026'),
    videoImage: angelImagesUrl('v1761673219/iwas/IWAS-trialer-image.webp'),
    releaseDate: 'January 9, 2026',
    backgroundVideoUrl:
      'https://content.angelstudios.com/i-was-a-stranger/I%20Was%20A%20Stranger_tLoopingVideo_20s_l-en_wNOCAPS_16x9_f23_y20250923_iAA.mp4',
    share: {
      shareText:
        'The upcoming @AngelStudios movie I Was a Stranger in theaters on January 9th. Preorder tickets for a chance to win the Paths of Hope Trip!',
      hashtag: '#IWASGiveaway2',
      shareImage: angelImagesUrl('v1761673293/iwas/open-graph-image.webp'),
      shareImageMobile: angelImagesUrl('v1761673293/iwas/open-graph-image.webp'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.iWasAStranger,
      congratsKey: 'iwasCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Paths of Hope Trip! Complete your checkout to secure your entries.",
      reservationKey: 'iwasReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Paths of Hope Trip!",
      noShowtimesKey: 'iwasNoShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the Paths of Hope Trip!",
      portraitImage: staticAssetUrl('v1762881206/studio-app/catalog/49eba7f7-56ca-4106-bdc3-7c7bca3c7346.webp'),
      landscapeImage: staticAssetUrl('v1762880345/studio-app/catalog/9b71e162-47e6-402b-92c8-d25e7acca434.webp'),
    }),

    steps: [
      {
        title: t('preOrderTickets', 'Pre-Order Tickets'),
        description: t('IwasChooseYourTickets', 'Choose your tickets to I Was a Stranger below.'),
      },
      {
        title: t('receiveYourPromoCodes', 'Receive Your Promo Codes'),
        description: t(
          'eachTicketEarnsAPromoCode',
          'Each ticket earns you a unique promo code (redeemable when showtimes are available).',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreTicketsYouBuy',
          'The more tickets you buy, and the earlier you buy them, the greater your entry multiplier, boosting your odds of winning!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
